import { create } from 'zustand';

export const tripProfileStore = (set) => ({
  openTripProfile: false,
  tripId: '',
  legId: '',
  isRefreshLegListFromTripView: 0,
  dataSourceIdForTrip: '',
  openTripData: {},
  setOpenTripProfileView: (data) => {
    set({ openTripProfile: data });
  },
  setTripId: (data) => {
    set({ tripId: data });
  },
  setLegId: (data) => {
    set({ legId: data });
  },
  setIsRefreshLegListFromTripView: (data) => {
    set({ isRefreshLegListFromTripView: data + 1 });
  },
  setDataSourceIdForTrip: (data) => {
    set({ dataSourceIdForTrip: data });
  },
  setOpenTripData: (data) => {
    set({ openTripData: data });
  },
});
export const useTripProfileStore = create(tripProfileStore);
